import { useEffect, useState } from "react";
import { useAuth } from "./auth";
import { useHistory } from "react-router-dom";
import api from "../services/api";

interface IFavorites {
  id: number;
  favorite_id: number;
}

function useMultiplesFavorites(
  isInitiallyFavorite: boolean,
) {
  const { user, access_token } = useAuth();
  const [loadingFavorite, setLoadingFavorite] = useState(false);
  const [isFavorite, setIsFavorite] = useState(isInitiallyFavorite);

  const history = useHistory();

  async function handleFavorite(property_id: number) {
    if (!user) {
      return history.push({
        pathname: "/login",
        state: { fromSite: true },
      });
    }

    setLoadingFavorite(true);

    api.defaults.headers.authorization = `Bearer ${access_token}`;

    const response = await api.post("/api/client/tenant/favorites", {
      property_id: String(property_id),
    });

    if (!!response.data.success) {
      setIsFavorite(true);
    }

    setLoadingFavorite(false);
  }

  async function handleRemoveFavorite(property_id: number) {
    setLoadingFavorite(true);

    api.defaults.headers.authorization = `Bearer ${access_token}`;

    const response = await api.get("/api/client/tenant/favorites");

    const filter = response.data.data.find(
      (apiResponse: IFavorites) => apiResponse.id === property_id
    );

    if (!!filter) {
      const apiResponse = await api.delete(
        `api/client/tenant/favorites/${filter.favorite_id}`
      );

      if (!!apiResponse.data.success) {
        setIsFavorite(false);
      }
    }

    setLoadingFavorite(false);
  }

  return { loadingFavorite, isFavorite, handleFavorite, handleRemoveFavorite };
}

export default useMultiplesFavorites;
